export function phonePlainToMask (phone) {
    return `+${phone[1]} (${phone.slice(2, 5)}) ${phone.slice(5, 8)}-${phone.slice(8, 10)}-${phone.slice(10)}`
}

export function phoneMaskToPlain (phone) {
    return phone.replace(/[^\d+]/g, '')
}